import { feedbackRequestAggregation } from './feedback-requests.aggregation';
import { runAggregation } from '@/utils/aggregation';
import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';

const feedbackRequests = {
    namespaced: true,
    state: {
        error: {},
        fetching: false,
        map: {},
    },
    mutations: {
        setFetching (state, { isFetching }) {
            state.fetching = isFetching;
        },
        setMap (state, { map }) {
            state.map = map;
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        async loadAll ({ commit, state }, { reFetch = false } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }

            try {
                commit('setFetching', { fetching: true });
                const feedbackRequests = await runAggregation(feedbackRequestAggregation());
                commit('setFetching', { fetching: false });
                commit('setMap', { map: feedbackRequests });
            } catch (error) {
                commit('setFetching', { fetching: false });
                commit('setError', { error });
                throw error;
            }
        },
    },
    getters: {
        list: (state) => values(state.map),
    },
};

export default feedbackRequests;
